import styles from './Analytics.module.scss';

export default function Analytics() {
  return <div className={styles.analytics}>Analytics. Page in progress...</div>;
}
